import { FC } from "react";
import { Outlet } from "react-router-dom";
import { Footer } from "../common/Footer";
import NavBar from "../common/NavBar";
import { UNDERDOTS_FORM } from "../constants";
import { JobEstimate } from "../JobEstimate";

type UnderdotsShellProps = {};

const UnderdotsShell: FC<UnderdotsShellProps> = () => {
  const sections = UNDERDOTS_FORM.map((section) =>
    typeof section === "string" ? section : section.title
  );
  return (
    <>
      <div className="min-h-screen w-full bg-gray-100 flex flex-col justify-normal items-center">
        <NavBar />
        <div className="grow grid grid-cols-6 gap-4 mx-auto w-full max-w-5xl px-5">
          <div className="col-span-6 md:col-span-2">
            <JobEstimate sections={sections} openLinkInNewWindow={false} />
          </div>
          <div className="col-span-6 md:col-span-4">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default UnderdotsShell;
